<template>
  <div class="listItem" :class="type">
    <div class="flex-center-y text-15" v-if="type === 'bonus'">
      <div class="flex-center-y font-[500]"> <img src="@a/assets/images/i_money2.png" class="size-6 mr-2" /> {{ $t('Activities.Bonus.Bonus') }} </div>
      <span class="font-[500] ml-auto">R$:{{ formatter().format(+item.rewardAmount!) }}</span>
    </div>

    <div v-if="type === 'ggc'">
      <div class="flex">
        <img src="@a/assets/images/i_ggc.png" class="size-6 mr-2" />
        <p class="text-15 font-[500] flex-1">{{ $t('Activities.Bonus.ScratchCards') }}</p>
        <div class="font-[500]">
          <span class="text-15 mr-1">1</span><span class="text-11 text-white/75">{{ $t('Activities.Bonus.ticket') }}</span>
        </div>
      </div>

      <p class="text-11 text-white/50 mt-1 mx-8">{{ $t('Activities.Bonus.BonusRange') }}</p>
    </div>

    <div class="flex-between-center text-12 text-white/75 mt-1">
      <div class="text-13 truncate mr-2">
        <span class="text-white/50 mr-2">{{ $t('Activities.Bonus.Period') }}</span>
        <span class="text-white/75">{{ item.id }}</span>
      </div>

      <div class="h-8.5 font-[600] text-15 w-24">
        <span v-if="status === 'Awarded'" class="primaryBtn-sm" @click="receber">{{ $t('Activities.Bonus.ToReceive') }}</span>
        <span v-if="status === 'Received'" class="btn_disabled px-2">{{ $t('Activities.Bonus.Rescued') }}</span>
        <span v-if="status === 'Expired'" class="btn_disabled opacity-50">{{ $t('Activities.Bonus.Expired') }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="tsx">
  import {  type tStatus, type iBonusHistoryItem } from '@/types/index'
  import showPopup from '@a/components/showPopup'
  import Tip from '@a/components/Tip/index.vue'
  import { formatter } from '@/utils'

  const props = withDefaults(defineProps<{
    type: 'bonus' | 'ggc';
    status: tStatus;
    item: iBonusHistoryItem
  }>(), {
    type: 'bonus',
    status: 'Awarded',
    item: () => ({}) as iBonusHistoryItem
  });

  const emit = defineEmits(['success'])

  const receber = async () => {
    showPopup(<Tip
      type='bonus'
      flowType="DepositReward"
      amount={props.item.rewardAmount}
      rewardId={props.item.id.toString()}
      activityId={props.item.activityId.toString()}
      onSuccess={() => emit('success')}
    />)
  }
</script>

<style lang="scss" scoped>
  .listItem{
    @apply px-4 py-2.5 mx-4 mt-4 rounded-8;

    &.bonus{
      @apply bg-[var(--theme-gray-green40)];
    }

    &.ggc{
      @apply bg-[var(--theme-gray-green20)];
    }
  }
</style>
